import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { PhoneNumberWithPrefixRequest } from '@web/shared/module/dictionary';

@jsonObject
export class PublicCartBillingAddressRequest {
  @jsonMember(String)
  public readonly firstName!: string;

  @jsonMember(String)
  public readonly lastName!: string;

  @jsonMember(PhoneNumberWithPrefixRequest)
  public readonly phone!: PhoneNumberWithPrefixRequest;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly streetLine1!: string;

  @jsonMember(String)
  public readonly streetLine2?: Nillable<string>;

  @jsonMember(String)
  public readonly postCode!: string;

  @jsonMember(String)
  public readonly city!: string;

  @jsonMember(String)
  public readonly state?: Nillable<string>;

  @jsonMember(String)
  public readonly companyName?: Nillable<string>;

  @jsonMember(String)
  public readonly companyNip?: Nillable<string>;

  @jsonMember(String)
  public readonly country!: Guid;

  public constructor(
    private readonly data: {
      firstName: string;
      lastName: string;
      phone: PhoneNumberWithPrefixRequest;
      email: string;
      streetLine1: string;
      streetLine2?: Nillable<string>;
      postCode: string;
      city: string;
      state?: Nillable<string>;
      companyName?: Nillable<string>;
      companyNip?: Nillable<string>;
      country: Guid;
    },
  ) {
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.phone = data.phone;
    this.email = data.email;
    this.streetLine1 = data.streetLine1;
    this.streetLine2 = data.streetLine2;
    this.postCode = data.postCode;
    this.city = data.city;
    this.state = data.state;
    this.companyName = data.companyName;
    this.companyNip = data.companyNip;
    this.country = data.country;
  }
}
